import { render, staticRenderFns } from "./TagRule.vue?vue&type=template&id=5271d86a&"
import script from "./TagRule.vue?vue&type=script&lang=js&"
export * from "./TagRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports